import idb from "@/plugins/indexdb.js";
import MoldedSeatRepository from "@/repositories/products/moldedSeatRepository.js";

const uuidv4 = require("uuid/v4");

// Initial state
function initialState() {
  return {
    moldedSeat: {
      type: "FOAM",
      part: "CS",


      idc_bracket: false,
      bracket: null,
      bracket_type: null,
      spin_color_id: null,
      spin_type: null,
      spin_size: null,
      palma_color_id: null,
      bracket_fr: null,
      bracket_fr_width: null,
      bracket_fr_depth: null,
      bracket_other: null,
      bracket_other_width: null,
      bracket_other_depth: null,
      bracket_location: null,
      bracket_serial_number: null,

      idc_integrated_in_chair: false,
      idc_hinged_hinge: false,
      idc_in_2_parts: false,
      transfer_id: null,
      max_hull_width: null,
      hull_angle: null,
      hardware: null,
      idc_symmetrical_rectif: false,

      idc_stud: false,
      stud_type: null,
      fixed_stud: null,
      removable_type: null,
      other_stud: null,

      thickness_plasta: null,
      thickness_evazote: null,
      thickness_foam: null,
      idc_anti_pressure_ulcers: false,
      matter: null,
      idc_coating: false,
      plastazote_color_id: null,
      thermozaique_color_id: null,
      evazote_color_id: null,
      backrest: null,
      seated: null,
      intern_skai_color_id: null,
      extern_skai_color_id: null,
      skai_comment: null,
      fitting_comment: null,
      a: null,
      b: null,
      c: null,
      d: null,
      e: null,
      f: null,
      g: null,
      h: null,
      i: null,
      j: null,
      k: null,
      l: null,
      m: null,
      n: null,

      idc_cover: false,
      cover_type: null,
      cover_color_type: null,
      intern_cover_id1: null,
      intern_cover_id2: null,
      intern_cover_id3: null,
      intern_cover_id4: null,
      intern_hs_id1: null,
      intern_hs_id2: null,
      intern_hs_id3: null,
      intern_hs_id4: null,
      extern_cover_id1: null,
      extern_cover_id2: null,
      extern_cover_id3: null,
      extern_cover_id4: null,
      extern_hs_id1: null,
      extern_hs_id2: null,
      extern_hs_id3: null,
      extern_hs_id4: null,
      wave_intern_cover_id1: null,
      wave_intern_cover_id2: null,
      wave_intern_cover_id3: null,
      wave_intern_cover_id4: null,
      wave_intern_hs_id1: null,
      wave_intern_hs_id2: null,
      wave_intern_hs_id3: null,
      wave_intern_hs_id4: null,
      wave_extern_cover_id1: null,
      wave_extern_cover_id2: null,
      wave_extern_cover_id3: null,
      wave_extern_cover_id4: null,
      wave_extern_hs_id1: null,
      wave_extern_hs_id2: null,
      wave_extern_hs_id3: null,
      wave_extern_hs_id4: null,
      alcantara_id: null,
      three_d_id: null,

      shoulder_pad_position: null,
      shoulder_pad_size_trap: null,
      shoulder_pad_strap_matter: null,
      shoulder_pad_velcro: null,
      shoulder_pad_clip: null,
      shoulder_pad_cushion: null,
      shoulder_pad_workshop: null,
      thorax_position: null,
      thorax_size_trap: null,
      thorax_strap_matter: null,
      thorax_velcro: null,
      thorax_clip: null,
      thorax_cushion: null,
      thorax_workshop: null,
      chest_position: null,
      chest_size_trap: null,
      chest_strap_matter: null,
      chest_velcro: null,
      chest_clip: null,
      chest_cushion: null,
      chest_workshop: null,
      pelvis_position: null,
      pelvis_size_trap: null,
      pelvis_strap_matter: null,
      pelvis_velcro: null,
      pelvis_clip: null,
      pelvis_cushion: null,
      pelvis_workshop: null,
      femoral_position: null,
      femoral_size_trap: null,
      femoral_strap_matter: null,
      femoral_velcro: null,
      femoral_clip: null,
      femoral_cushion: null,
      femoral_workshop: null,
      tibial_position: null,
      tibial_size_trap: null,
      tibial_strap_matter: null,
      tibial_velcro: null,
      tibial_clip: null,
      tibial_cushion: null,
      tibial_workshop: null,
      foot_position: null,
      foot_size_trap: null,
      foot_strap_matter: null,
      foot_velcro: null,
      foot_clip: null,
      foot_cushion: null,
      foot_workshop: null,
      wrist_position: null,
      wrist_size_trap: null,
      wrist_strap_matter: null,
      wrist_velcro: null,
      wrist_clip: null,
      wrist_cushion: null,
      wrist_workshop: null,
      mounting_comment: null,

      idc_adaptation_support: false,
      adaptation_support_type: null,
      adaptation_support_backrest_strap: null,
      idc_adaptation_support_backrest_button: false,
      adaptation_support_backrest_velcro: null,
      idc_adaptation_support_backrest_flex: false,
      idc_adaptation_support_backrest_rigid: false,
      adaptation_support_seated_strap: null,
      idc_adaptation_support_seated_button: false,
      idc_adaptation_support_seated_flex: false,
      idc_adaptation_support_seated_rigid: false,
      adaptation_support_comment: null,

      breastplate_module: {
        idc_breastplate: false,
        breastplate: null,
        breastplate_type: null,
        size: null,
        a: null,
        b: null,
        c: null,
        d: null,
        e: null,
        construction_type: null,
        idc_shoulder_socket: false,
        idc_adjustment_cebelor: false
      },
      socle_module: {
        idc_socle: false,
        width: null,
        depth: null,
        thickness: null,
        tilt: null,
        idc_schematic: false,
        matter: null,
        socle_color_id: null,
        blob: null
      },
      headrest_module: {
        idc_headrest: false,
        renew: null,
        type: null,
        headrest_type: null,
        albatros_size: null,
        mounting_type: null,
        idc_thierry: false,
        vital_scrolling: null,
        finishing: null,
        mounting: null,
        a: null,
        b: null,
        c: null
      },
      armrest_module: {
        right_orthosis_type: null,
        right_insert_type: null,
        right_position: null,
        left_orthosis_type: null,
        left_insert_type: null,
        left_position: null,
        finishing: null,
        a: null,
        b: null,
        comment: null
      },
      tablet_module: {
        idc_tablet: false,
        type: null,
        idc_standard: false,
        matter: null,
        tablet_type: null,
        comeback: null,
        a: null,
        b: null,
        c: null,
        d: null,
        e: null,
        f: null
      },
      leg_segment_module: {
        idc_leg_segment: false,
        position: null,
        right: null,
        left: null,
        a: null,
        b: null,
        c: null,
        comment: null
      },
      pedal_segment_module: {
        right: null,
        left: null,
        a: null,
        b: null,
        c: null
      },
      footrest_module: {
        idc_footrest: false,
        exist: null,
        position: null,
        form: null,
        idc_knees: false,
        idc_ankles: false,
        idc_foldable: false,
        idc_separated: false,
        idc_right: false,
        idc_left: false,
        right: null,
        left: null,
        leg_length: null,
        legrest_angle: null,
        footrest_angle: null,
        foot_finishing: null,
        calf_finishing: null,
        a: null,
        b: null,
        c: null,
        d: null,
        comment: null
      },
      articles: []
    }
  };
}

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    // Set molded seat
    SET_MOLDED_SEAT(state, molded_seat) {
      state.moldedSeat = Object.assign({}, state.moldedSeat, molded_seat);
    },

    // Clean molded seat object
    RESET_MOLDED_SEAT(state) {
      state.moldedSeat = initialState().moldedSeat;
    }
  },
  actions: {
    // Set product
    setProduct: ({ commit }, product) => {
      commit("SET_MOLDED_SEAT", product);
    },

    // Reset product
    resetProduct({ commit }) {
      commit("RESET_MOLDED_SEAT");
    },

    // Creates product in IndexedDB
    async createLocalMoldedSeat({ commit, state }, molded_seat) {
      molded_seat.uuid = uuidv4();
      commit("SET_MOLDED_SEAT", molded_seat);

      return await idb.db.molded_seat.add(state.moldedSeat);
    },

    // Get molded seat from API
    async getMoldedSeat(context, molded_seat_uuid) {
      try {
        const { data } = await MoldedSeatRepository.getMoldedSeat(
          molded_seat_uuid
        );
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Get molded seat product by uuid
     *
     * @param {String} molded_seat_uuid molded seat uuid
     */
    async get(context, molded_seat_uuid) {
      try {
        const { data } = await MoldedSeatRepository.get(molded_seat_uuid);
        // commit("SET_OTN", data);
        return data;
      } catch (error) {
        throw error;
      }
    },

    /**
     * Create molded seat product on server
     *
     * @param payload Molded seat payload
     */
    async createMoldedSeat(context, payload) {
      try {
        const { data } = await MoldedSeatRepository.create(payload);
        return data;
      } catch (error) {
        const errorCode = error.response.data.error;

        if (errorCode === "ERROR_PRODUCT_MOLDED_SEAT_ALREADY_EXISTS") {
          throw new Error("Siège moulé déjà existant");
        }
      }
    },

    // Gets molded seat from IndexedDB
    async getLocalMoldedSeat({ commit }, molded_seat_uuid) {
      const product = await idb.db.molded_seat.get(molded_seat_uuid);

      if (!product) {
        throw new Error(`Fiche non trouvée. UUID: ${molded_seat_uuid}`);
      }

      commit("SET_MOLDED_SEAT", product);

      return product;
    }
  }
};
